module.exports = __webpack_public_path__ + "img/R-4.8c1ca06b.png";